import { OrganizationCoreBase } from "./organization.core.base"


export class OrganizationCore extends OrganizationCoreBase {

}